import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { PlusSquare } from "react-feather";

//Forms
import UpdateCompanyLogoForm from "./UpdateCompanyLogoForm";

interface ModalProps {
  company_code: string;
  modal: boolean;
  toggle?: () => void;
}

const UpdateLogoModal: React.FC<ModalProps> = ({
  company_code,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Company Logo</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Set New Company Logo
            </P>
          </ModalHeader>
          <UpdateCompanyLogoForm toggle={toggle} company_code={company_code} />
        </div>
      </Modal>
    </>
  );
};
export default UpdateLogoModal;
